declare namespace $ {

	export class $bog_worm_slider extends $mol_view {
		least( ): number
		most( ): number
		step( ): number
		hint( ): string
		value_text( ): string
		event_change( next?: any ): any
		dom_name( ): string
		value( next?: number ): number
		minimal_height( ): number
		attr( ): ({ 
			'type': string,
			'min': ReturnType< $bog_worm_slider['least'] >,
			'max': ReturnType< $bog_worm_slider['most'] >,
			'step': ReturnType< $bog_worm_slider['step'] >,
			'aria-label': ReturnType< $bog_worm_slider['hint'] >,
		})  & ReturnType< $mol_view['attr'] >
		field( ): ({ 
			'value': ReturnType< $bog_worm_slider['value_text'] >,
		})  & ReturnType< $mol_view['field'] >
		event( ): ({ 
			input( next?: ReturnType< $bog_worm_slider['event_change'] > ): ReturnType< $bog_worm_slider['event_change'] >,
		})  & ReturnType< $mol_view['event'] >
	}
	
}

//# sourceMappingURL=slider.view.tree.d.ts.map